<template>

    <v-container fluid grid-list-md class="price-list pt-0 pl-0 pr-0">
        <v-card>
            <v-toolbar color="white"
                       white
            >
                <v-toolbar-title>
                    Bảng giá dịch vụ
                </v-toolbar-title>

                <v-spacer></v-spacer>
            </v-toolbar>

            <div class="container-tabs" v-if="maintain">
                <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
            </div>

            <v-container fluid v-else>
                <v-row>
                    <v-col md="3">
                        <v-row>
                            <v-col md="12">
                                <v-card class="profile-card">
                                    <v-img src="https://image.freepik.com/free-vector/man-avatar-profile-round-icon_24640-14044.jpg"
                                           height="300px"
                                           dark
                                    >
                                    </v-img>

                                    <v-list two-line>
                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-account
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Tên: <strong>{{ this.user.name }}</strong>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-camera-timer
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Ngày tham gia: <strong>{{ this.user.created_at
                                                    }}</strong></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item v-if="user.show_level">
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-trophy-award
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Level: <strong>{{ this.user.customer_level
                                                    }}</strong></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-phone
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Điện thoại: <strong>{{ this.user.mobile }}</strong>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-divider inset></v-divider>

                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-email
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Email: <strong>{{ this.user.email }}</strong>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-divider inset></v-divider>

                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-cash
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Số dư: <strong>{{ this.user.customer_coin }} coin</strong>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4">
                                                mdi-cash-usd
                                            </v-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Tổng nạp trong tháng: <strong>{{
                                                    this.user.customer_money_in_month }} coin</strong></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item v-if="this.user.total_coin_next_level !== 0">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-row justify="space-between"
                                                    >
                                                        <v-col md="4" class="text-left">
                                                            {{ this.user.customer_level }}
                                                        </v-col>
                                                        <v-col md="4" class="text-right">
                                                            {{ this.user.next_level }}
                                                        </v-col>
                                                    </v-row>
                                                    <v-progress-linear
                                                            color="light-green darken-4"
                                                            height="20"
                                                            :value="progressLevel"
                                                            striped
                                                    >
                                                        <template v-slot:default="{ value }">
                                                            {{ Math.ceil(value) }}%
                                                        </template>
                                                    </v-progress-linear>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                            <v-col md="12">
                                <v-card class="profile-card">
                                    <v-list two-line v-for="(level, key) in user.up_level" :key="key">
                                        <v-list-item>
                                            <v-icon color="indigo" class="mr-4 mb-4">
                                                mdi-arrow-up-bold-hexagon-outline
                                            </v-icon>
                                            <v-list-item-content>
                                                <v-list-item-title><strong>{{ level.name }}</strong></v-list-item-title>
                                                <v-list-item-subtitle>Có 1 giao dịch nạp tiền {{ level.money_up }} hoặc
                                                    tổng nạp {{ level.money_total }}.
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col md="9">
                        <v-card class="price-card" color="basil">
                            <v-card-title class="text-center justify-center py-6">
                                <h2 class="font-weight-bold basil--text">
                                    <v-icon class="font-weight-bold basil--text" style="font-size: 30px; vertical-align: initial">mdi-currency-usd</v-icon>
                                    Bảng giá chi tiết (đơn vị: coin)
                                </h2>
                            </v-card-title>
                            <v-card>
                                <v-simple-table fixed-header height="1000px">
                                    <template v-slot:default>
                                        <thead class="price-head">
                                        <tr>
                                            <th>Loại / Level</th>
                                            <th v-for="(level, key) in levels" class="text-left"
                                                :key="'head' + key">
                                                {{ level.name }}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-for="(group, key) in seedingTypes">
                                            <tr :key="key" :class="color(key)">
                                                <td colspan="4">
                                                    <h3>{{ groupName(key) }}</h3>
                                                </td>
                                            </tr>
                                            <tr v-for="(item, k) in group" :key="key + k">
                                                <td class="pl-8">
                                                    <img style="vertical-align: sub" :src="item.icon" height="30px">
                                                    <span style="vertical-align: super"> {{ item.name }}</span>
                                                </td>

                                                <td v-for="(price, key) in item.price" :key="key">
                                                    <p v-if="item.price !== undefined">{{ price }}</p>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
<!--                            <v-text-field-->
<!--                                    v-model="searchSeedingType"-->
<!--                                    append-icon="mdi-magnify"-->
<!--                                    label="Search"-->
<!--                                    single-line-->
<!--                                    hide-details-->
<!--                            ></v-text-field>-->
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
  import {
    CUSTOMER_LEVEL_PRICE_LIST,
    CUSTOMER_LEVEL_PROFILE
  } from '~/store/actions.type'

  import {
    COMMON_SET_LOADING
  } from '../../store/mutations.type'

  export default {
    components: {},
    data () {
      return {
        currentItem: '#tab-seeding',
        maintain: false,
        tab: null,
        items: [
          'Dịch vụ seeding', 'Dịch vụ view', 'Reaction facebook',
        ],
        levels: [],
        seedingTypes: {
        },
        searchUview: '',
        searchReaction: '',
        user: {},
      }
    },

    methods: {
      async getLevelList () {
        this.$store.commit(COMMON_SET_LOADING, true)
        let data = await this.$store.dispatch(CUSTOMER_LEVEL_PRICE_LIST)
        this.levels = data.level
        this.seedingTypes = data.data
        this.$store.commit(COMMON_SET_LOADING, false)
      },

      async initDefault () {
        this.user = await this.$store.dispatch(CUSTOMER_LEVEL_PROFILE)
      },

      groupName (name) {
        let label = name.split('+')
        return label[0]
      },

      color (name) {
        let label = name.split('+')
        return label[1]
      }
    },

    mounted () {
      this.initDefault()
      this.getLevelList()
    },

    computed: {
      progressLevel () {
        return (this.user.customer_money_in_month / this.user.total_coin_next_level) * 100
      },
    }
  }
</script>
<style lang="scss">
    @import "../../scss/main";

    .headline {
        background-color: #ffffff;
        margin-top: 0 !important;
        border-radius: 15px 15px 0 0;
        padding: 5px;
    }

    .basil {
        background-color: #FFFBE6 !important;
    }

    .basil--text {
        color: #356859 !important;
    }

    .v-list-item__subtitle {
        text-overflow: inherit !important;
        white-space: inherit !important;
    }
</style>

<style scoped>
    .price-head th {
        font-size: 16px;
    }
</style>

